<template>
  <div id="work" class="section bg-filter">
    <div
      class="container"
      data-aos="fade-left"
      data-aos-delay="20"
      data-aos-duration="500"
    >
      <h3 class="is-size-3 has-text-white">{{ $t("work.tittle") }}</h3>
      <hr class="line" />
      <br />
      <p class="has-text-white">{{ $t("work.descript") }}</p>
      <figure
        class="image is-16by9"
        v-if="currentLocale == 'en' || currentLocale == 'pt'"
      >
        <iframe
          class="has-ratio"
          width="640"
          height="360"
          src="https://www.youtube.com/embed/Y9XnpHYrWoM?showinfo=0"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </figure>
      <figure class="image is-16by9" v-if="currentLocale == 'es'">
        <iframe
          class="has-ratio"
          width="640"
          height="360"
          src=" https://www.youtube.com/embed/FoxXmKe3d0E?showinfo=0"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </figure>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n.js";
import ModalVideo from "@/components/videoModal.vue";
export default {
  name: "Work",
  data() {
    return {
      isImageModalActive: false,
    };
  },
  methods: {
    cardModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalVideo,
        hasModalCard: false,
        trapFocus: true,
      });
    },
  },
  computed: {
    currentLocale() {
      return i18n.locale;
    },
  },
};
</script>
<i18n>
{
  "es": {
    "work": {
      "tittle":"Cómo Funciona",
      "cepEnter":"",
      "cepAnalysis":"",
      "cepOut":"",
      "descript":"Ceptinel está basado en tecnología CEP (Complex Event Processing), un panel de reglas gráfico en tiempo real y generación de alertas oportunas para tomar decisiones."
    }
  },
  "en": {
    "work": {
      "tittle":"How does it work?",
      "cepEnter":"",
      "cepAnalysis":"",
      "cepOut":"",
      "descript":"Ceptinel is based on CEP (Complex Event Processing) technology, a real-time graphical rules panel and generation of timely alerts to make decisions."
    }
  },
  "pt": {
    "work": {
      "tittle":"Como funciona",
      "cepEnter":"",
      "cepAnalysis":"",
      "cepOut":"",
      "descript":"O Ceptinel é baseado na tecnologia CEP (Complex Event Processing), um painel gráfico de regras em tempo real e a geração de alertas oportunos para a tomada de decisões."
    }
  }
}
</i18n>
